import React, { useEffect, useState } from 'react';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_CITY_GUIDE,
} from '../../../../../constants/RoleConsts';
import {
  CITY_GUIDE_ADD_ACTIVITY_TAB,
  CITY_GUIDE_EDIT,
} from '../../../../../constants/CityGuideConst';
import { useSelector } from 'react-redux';
import { cityGuideSelector } from '../../../cmsSlice';
import CityGuideDetailView from './City-Guide-Detail-View';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';

const CityGuideView = (props) => {
  const { toggleDrawer, cityGuide, permissions, onViewToggle } = props;
  const cityGuideList = useSelector(cityGuideSelector);
  const [tabValue, setTabValue] = useState(0);
  const [selectedCityGuide, setSelectedCityGuide] = useState(null);

  useEffect(() => {
    if (cityGuideList.length) {
      const currOffer = cityGuideList.find((o) => o.id === cityGuide.id);
      setSelectedCityGuide(currOffer);
    }
  }, [cityGuideList, cityGuide.id]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, selectedCityGuide);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(CITY_GUIDE_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <CityGuideDetailView tabValue={tabValue} cityGuide={selectedCityGuide} />;
  };

  return (
    <>
      {selectedCityGuide && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={CITY_GUIDE_ADD_ACTIVITY_TAB}
          tabClass='col-md-6'
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          createdUserId={selectedCityGuide?.createdBy}
          isEditable={permissions[RBAC_TYPE_CMS_CITY_GUIDE] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          isHeightIncluded={true}
          title={selectedCityGuide?.name}
        />
      )}
    </>
  );
};

export default CityGuideView;
